import { useQuery } from '@tanstack/react-query';
import * as ep from '../api/endpoints';
import { yearMonthLabel } from '../lib/dates';

/** Ay seçici: açık/kapalı durumu metinle gösterilir. */
export function PeriodPicker({ value, onChange }: { value: string | undefined; onChange: (id: string) => void }) {
  const q = useQuery({ queryKey: ['periods'], queryFn: ep.periods });
  const list = q.data ?? [];
  return (
    <select aria-label="Dönem seçin" value={value ?? list[0]?.id ?? ''} onChange={(e) => onChange(e.target.value)}>
      {list.map((p) => (
        <option key={p.id} value={p.id}>{yearMonthLabel(p.year_month)} — {p.status === 'CLOSED' ? 'Kapalı' : 'Açık'}</option>
      ))}
    </select>
  );
}

export function usePeriods() {
  return useQuery({ queryKey: ['periods'], queryFn: ep.periods });
}
